import SpeciesSelectMultiple from "./SpeciesSelectMultiple";
import SpeciesSelectSingle from "./SpeciesSelectSingle";
import { SpeciesSelectProps } from "./types";

export default function SpeciesSelect(props: SpeciesSelectProps) {
    return props.multiple ? <SpeciesSelectMultiple {...props} /> : <SpeciesSelectSingle {...props} />;
}
